import React from "react";
import { Box, Container, Typography } from "@mui/material";

const RefundPolicy = () => {
  return (
    <Container  sx={{ mt: 5, mb: 5 }}>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          padding: 4,
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Page Title */}
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", mb: 4, textAlign: "center", color: "#333" }}
        >
          Refund Policy
        </Typography>

        {/* Introduction */}
        <Typography variant="body1" sx={{ mb: 3 }}>
          At Farmology.ai, we strive to deliver high-quality SaaS solutions for
          our users. Our refund policy is designed to be fair and transparent,
          ensuring a seamless experience while protecting both our customers and
          our business.
        </Typography>

        {/* Subscription Fees & Refund Eligibility */}
        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3, mb: 2 }}>
          Subscription Fees & Refund Eligibility
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Farmology.ai offers both monthly and annual subscription plans. If you
          are unsatisfied with our service, you may request a refund under the
          following conditions:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              Refund requests must be made within <strong>24 Hours</strong> of the
              initial subscription purchase.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Refunds are not applicable for renewal payments.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              No refunds will be provided for usage exceeding 24 Hours.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Any promotional or discounted subscriptions are 
              <strong> non-refundable</strong>.
            </Typography>
          </li>
        </ul>

        {/* Cancellation Policy */}
        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3, mb: 2 }}>
          Cancellation Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Users can cancel their subscriptions at any time from their account
          settings. Once canceled, the subscription remains active until the end
          of the billing cycle. No partial refunds are provided for unused
          portions of a subscription period.
        </Typography>

        {/* Refund Process */}
        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3, mb: 2 }}>
          Refund Process
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          To request a refund, contact our support team at
          <strong> info@farmologyindia.com</strong> with the following details:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              Your registered email address
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Transaction ID or invoice details
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Reason for the refund request
            </Typography>
          </li>
        </ul>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Refunds will be processed within <strong>7-10 business days</strong>{" "}
          upon approval. Refunds will be credited back to the original payment
          method.
        </Typography>

        {/* Exceptions */}
        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3, mb: 2 }}>
          Exceptions
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We do not offer refunds under the following circumstances:
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              Violations of our Terms of Service
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Failure to cancel before renewal
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Usage beyond the refund window
            </Typography>
          </li>
        </ul>

        {/* Changes to Refund Policy */}
        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3, mb: 2 }}>
          Changes to Refund Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Farmology.ai reserves the right to modify or update this refund policy
          at any time. Changes will be effective immediately upon posting on our
          website.
        </Typography>

        {/* Contact Information */}
        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 3, mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="body1">
          If you have any questions about our refund policy, please contact us
          at <strong>info@farmologyindia.com</strong>.
        </Typography>
      </Box>
    </Container>
  );
};

export default RefundPolicy;
